/**
 * The `job_priority` lookup names, as stored (title case).
 *
 * 'Unknown' is a real, selectable priority meaning "not specified" — it is part
 * of the closed set, not an absence of one. Excluding it made unset jobs fall
 * through to Low styling, which is what SC-6369 was raised about.
 *
 * Lowercase slugs for colour maps and the map legend live in
 * `@/shared/lib/priority` (`JOB_PRIORITIES` / `mapPriority`); this module is the
 * display-name view of the same closed set.
 */
export type Priority = 'Critical' | 'High' | 'Medium' | 'Low' | 'Unknown';

const KNOWN_PRIORITIES = new Set<string>(['Critical', 'High', 'Medium', 'Low', 'Unknown']);

/** True when `name` is one of the closed-set Priority values. */
export function isPriority(name: string | null | undefined): name is Priority {
  return name !== null && name !== undefined && KNOWN_PRIORITIES.has(name);
}
